import { render, staticRenderFns } from "./issue-type.vue?vue&type=template&id=31e7a53e"
import script from "./issue-type.vue?vue&type=script&lang=js"
export * from "./issue-type.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports